import { ClassEnum, SETTING_TYPE } from '@/constants/enum';
import { getColor } from '@/helpers';
import { widgetColorSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  type?: SETTING_TYPE;
}

const AdditionalMessage = ({ type }: IProps) => {
  const widgetTextDetail = useSelector(widgetTextDetailSelector);
  const widgetSettings = useSelector(widgetSettingSelector);
  const widgetColors = useSelector(widgetColorSelector);

  const widgetShippingTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.SHIPPING),
    [widgetTextDetail.texts],
  );

  const widgetDeliveryTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.DELIVERY),
    [widgetTextDetail.texts],
  );

  const widgetPickupTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.PICKUP),
    [widgetTextDetail.texts],
  );

  const additionalMessages = useMemo(() => {
    switch (type) {
      case SETTING_TYPE.PICKUP:
        return widgetPickupTexts?.additionalMessages;
      case SETTING_TYPE.DELIVERY:
        return widgetDeliveryTexts?.additionalMessages;
      case SETTING_TYPE.SHIPPING:
        return widgetShippingTexts?.additionalMessages;
      default:
        return;
    }
  }, [
    type,
    widgetDeliveryTexts?.additionalMessages,
    widgetPickupTexts?.additionalMessages,
    widgetShippingTexts?.additionalMessages,
  ]);

  if (!additionalMessages) return;

  return (
    <div className={ClassEnum.AdditionalMessage} id="additional-message">
      <p
        className={ClassEnum.AdditionalMessageMinimumValue}
        id="pickup-additional-minimum-value"
        style={{ color: getColor(widgetSettings.colorScheme, widgetColors, 'body', 'additionalNotesColor') }}
      >
        {additionalMessages?.minimumOrderValue}
      </p>
      <p className={ClassEnum.AdditionalMessageMinimumWeight} id="pickup-additional-minimum-weight">
        {additionalMessages?.minimumOrderWeight}
      </p>
    </div>
  );
};

export default AdditionalMessage;
